import { DateCalendar } from '@mui/x-date-pickers/DateCalendar'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers'
import { DateTime } from 'luxon'

interface SpecificDatesCalendarProps {
  dates: DateTime[]
  setDates: (dates: DateTime[]) => void
}

export function SpecificDatesCalendar({ dates, setDates }: SpecificDatesCalendarProps) {
  const handleDateSelect = (value: unknown) => {
    // Convert value to Luxon DateTime
    const dateValue = DateTime.isDateTime(value) ? value : value ? DateTime.fromJSDate(value as Date) : null
    if (!dateValue || !dateValue.isValid) return
    const exists = dates.some(d => d.hasSame(dateValue, 'day'))
    if (exists) {
      setDates(dates.filter(d => !d.hasSame(dateValue, 'day')))
    } else {
      setDates([...dates, dateValue])
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <DateCalendar
        value={dates[dates.length - 1] || null}
        onChange={handleDateSelect}
        disableFuture
        slots={{
          day: (props: PickersDayProps) => {
            const isSelected = dates.some(d => d.hasSame(props.day, 'day'))
            return <PickersDay {...props} selected={isSelected} />
          }
        }}
      />
    </LocalizationProvider>
  )
}
